module.exports = __webpack_public_path__ + "img/SES_140254104.61bb0814.jpg";